<template>
  <div class="doc-container">
    <h1>用户协议</h1>
     <p>在您注册、登录赛刻体育平台、使用赛刻体育平台服务（以下简称“本服务”或“赛刻体育服务”）之前，应当仔细阅读并充分理解《赛刻体育服务条款》（以下简称“本服务条款”）全部内容。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。</p>
<p></p>
<p>未成年人则应在法定监护人陪同下阅读。如果您对本服务条款的任何条款表示异议，或者无法准确理解本服务条款，请不要访问和/或使用赛刻体育及本服务。您的注册、登录、访问赛刻体育、使用本服务等行为视为对本服务条款全部内容的接受，也意味您将接受本服务条款以及未来针对本服务条款更新版本条款的约束，并服从赛刻体育的统一管理。赛刻体育可能会不定期的更新本服务条款内容，您可在赛刻体育内页或网页上查阅最新版服务条款。更新后的服务条款一旦公布即代替原来的服务条款。服务条款更新后，如您不同意接受，您应停止使用赛刻体育提供的服务。</p>
<p></p>
<p>一、服务条款的确认和接纳</p>
<p></p>
<p>本服务条款是您（以下简称“用户”）与赛刻体育平台（以下简称“本平台”或“赛刻体育”）之间关于注册、登录赛刻体育、使用赛刻体育服务所订立的协议。</p>
<p></p>
<p>“用户”是指注册、登录、使用赛刻体育的个人。本服务的条款，内容包括条款正文、赛刻体育已经发布的或将来可能发布的各类公告、规则、协议。所有公告、规则、协议为本服务条款不可分割的组成部分，与条款正文具有同等法律效力。除另行明确声明外，用户使用本服务的行为将受本服务条款约束。</p>
<p></p>
<p>二、赛刻体育服务内容</p>
<p></p>
<p>赛刻体育是为广大足篮球爱好者提供订场、约赛、体育赛事数据分析的服务平台。</p>
<p></p>
<p>三、帐号注册、登录与使用</p>
<p></p>
<p>1 、用户登录帐号名称默认是用户本人的手机号，用户手机号出现问题造成无法登陆与赛刻体育无关。</p>
<p></p>
<p>2 、为使用户及时、全面了解赛刻体育提供的各项服务，用户同意，赛刻体育可以多次、长期向用户发送各类商业性消息推送而无需另行获得用户的同意。</p>
<p></p>
<p>3 、用户同意与注册、登录、使用赛刻体育帐号相关的一切资料、数据和记录，包括但不限于赛刻体育帐号、个人资料、所有登录和相关的使用统计数字等归赛刻体育所有。发生争议时，用户同意以赛刻体育的系统数据为准，赛刻体育保证该数据的真实性。</p>
<p></p>
<p>4 、用户有责任妥善保管赛刻体育帐号信息及帐号密码的安全，用户需要对赛刻体育帐号下的行为承担法律责任。由于账号、密码等信息外借、泄露或者被他人盗用而引起的法律责任，由用户自行承担。用户同意在任何情况下不使用其他用户的帐号。用户同意若发现任何非法使用用户帐号或安全漏洞的情况，有义务立即通告赛刻体育。</p>
<p></p>
<p>四、用户权利与义务</p>
<p></p>
<p>1 、用户不得以任何形式恶意注册赛刻体育（包括但不限于使用技术手段反复注册、堵塞赛刻体育网络通道等）。因各种形式的恶意注册而造成赛刻体育的损失，赛刻体育有权采取一切必要手段向用户追偿；造成的其他一切后果，由用户自行承担。</p>
<p></p>
<p>2、用户不得利用赛刻体育账户从事违法违规行为。用户不得利用其赛刻体育账户从事任何违法违规行为。</p>
<p></p>
<p>3 、若赛刻体育认为用户账号活动异常，赛刻体育有权对账号进行暂时冻结并进行调查。如调查后判定存在来源异常情形，情节严重者将进行账号封禁；来源异常情形包含但不限于：非赛刻体育认可的渠道购买，利用系统BUG、漏洞或外挂获得，其他非正当方式来源获得等。</p>
<p></p>
<p>4、用户必须为自己账号下发生的一切行为负责。用户违反本服务条款约定、或平台规范的，导致第三方向赛刻体育提出索赔等要求的，用户同意承担全部法律责任，包括但不限于赔偿金、罚金、和解费、诉讼仲裁费、合理的律师费支出等，并同意赔偿因此给赛刻体育造成的损害。用户承担赔偿责任的方式包括但不限于根据赛刻体育的书面通知向其支付与损失等额的资金等。</p>
<p></p>
<p>五、特别说明</p>
<p></p>
<p>为免疑义，用户在此不可撤销的确认其知悉并同意如下：赛刻体育所提供的服务仅限于本服务条款第二条所列范围，赛刻体育不从事彩票销售业务，也不提供彩票委托投注服务。</p>
<p></p>
<p>六、用户隐私制度</p>
<p></p>
<p>尊重用户隐私是赛刻体育的一项基本政策。赛刻体育将收集、存储、使用、披露和保护您的个人信息，以帮助您更好地保护您的个人信息。</p>
<p></p>
<p>七、知识产权</p>
<p></p>
<p>本服务中所涉及的赛刻体育图形、文字或其组成，以及其他赛刻体育标志及产品、服务名称，均为本平台标识。未经本平台事先书面同意，用户不得将本平台标识以任何方式展示、使用或申请注册商标、进行域名注册等，也不得实施向他人明示或暗示有权展示、使用、或其他有权处理本平台标识的行为。用户由于非法使用本平台标识给本平台或他人造成损失的，由用户承担相关法律责任。</p>
<p></p>
<p>八、免责声明</p>
<p></p>
<p>1 、用户因平台公告之系统停机维护、升级、调整，第三方原因如电信部门的通讯设备故障、计算机病毒或黑客攻击、技术问题、网络、电脑故障、系统不稳定性、台风、地震、海啸、洪水、停电、战争、恐怖袭击、政府管制及其他各种不可抗力原因而遭受的一切损失，赛刻体育及其合作单位不承担责任；赛刻体育对帐号上所有服务将尽力维护其安全性及方便性，但对服务中出现的信息（包括但不限于用户发布的信息）删除或储存失败不承担任何责任。因技术故障等不可抗事件影响到服务的正常运行的，赛刻体育及其合作单位承诺在第一时间内与相关单位配合，及时处理进行修复，但用户因此而遭受的一切损失，赛刻体育及其合作单位不承担责任。</p>
<p></p>
<p>2 、用户充分理解并同意：因业务发展需要、突发情势等，赛刻体育可能会变更，暂停、限制或者终止部分或全部服务，赛刻体育做出该等行为不需要事先进行通知。用户知悉并自愿承担该类风险及相关法律责任。</p>
<p></p>
<p>3 、赛刻体育提供的信息内容包括但不限于：文字、软件、声音、相片、录像、图表，在广告中的全部内容，以及本平台为用户提供的商业信息。上述所有信息均受著作权法、商标法和其它知识产权法以及物权法、其他相关中国法律的保护。用户只能在本平台和合作方明确授权的情况下才能使用这些内容，不得擅自实施包括但不限于复制、修改、编纂上述内容、或创造与该内容有关的衍生产品的行为。</p>
<p></p>
<p>九、法律</p>
<p></p>
<p>1 、本服务条款适用中华人民共和国的法律，并且排除一切冲突法规定的适用。</p>
<p></p>
<p>2 、因本服务条款引起的或与本服务条款有关的争议，赛刻体育可与用户协商解决。协商不成的，用户和赛刻体育一致同意将纠纷提交有关机构仲裁，仲裁裁决是终局的，对双方都有约束力。</p>
<p></p>
<p>十、附则</p>
<p></p>
<p>1 、赛刻体育不行使、未能及时行使或者未充分行使本服务条款或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响赛刻体育在将来行使该权利</p>
<p></p>
<p>2 、如本服务条款中的任何条款无论因何种原因完全或部分无效或不具有执行力，本服务条款的其余条款仍应有效且具有约束力，赛刻体育及用户均应尽力使该服务条款设定的本意得到实现。</p>
<p></p>
<p>3 、本服务条款中的标题仅为方便而设，不作为解释本服务条款的依据。</p>
<p></p>
<p>4 、如有任何疑问，请电话质询：【19142044013】</p>
  </div>
</template>

<script>
import { onMounted } from "vue";

export default {
  setup() {
    onMounted(() => {
      document.title = "用户协议";
    });
  },
};
</script>

<style scoped>
/* 彻底消除顶部空白 */
.doc-container {
  min-height: 100%;
}

/* h1 标题：居中 + 美观间距 */
h1 {
  text-align: center;
  margin: 0;
  padding: 20px 0 25px 0;   /* 上方留一点呼吸空间，下方与正文保持合适间距 */
  font-size: 24px;
  font-weight: bold;
  color: #2c3e50;
}

/* 正文段落：左右对齐（两端对齐） */
p {
  margin: 0 0 12px 0;       /* 段落底部间距 */
  text-align: justify;      /* 左右对齐 */
  text-justify: inter-ideograph;  /* 中文两端对齐更好看 */
  font-size: 10.5pt;
  font-family: 等线, "Microsoft YaHei", sans-serif;
  line-height: 1.7;         /* 建议增加行高，阅读更舒适 */
}

/* 标题 h2、h3 的样式（如果后续有的话） */
h2, h3 {
  margin: 18px 0 10px 0;
  text-align: left;
  font-size: 14px;
  font-weight: bold;
}

/* 整体容器样式 */
.doc-container {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;         /* 默认左对齐，h1单独居中 */
  color: #2c3e50;
  padding: 0 20px 30px 20px;   /* 左右留白，让正文不贴边，更美观 */
  box-sizing: border-box;
  max-width: 800px;         /* 可选：限制最大宽度，手机和电脑都好看 */
  margin: 0 auto;           /* 可选：内容居中显示 */
}
</style>
